import React, { FunctionComponent } from "react";

import styled from "styled-components";
import { rgba } from "polished";

const NavbarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    margin-bottom: 0;
    align-items: center;
    height: 100%;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const LinksContainer = styled.div`
  display: grid;
  grid-gap: 12px; /* Safari 10-11 */
  gap: 12px; /* Safari 12+ */
  grid-auto-flow: column;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    grid-gap: 12px; /* Safari 10-11 */
    gap: 12px; /* Safari 12+ */
  }
`;

export const NavbarLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
  position: relative;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textGrey};
  padding: 8px 12px;
  opacity: 0.56;
  border-radius: 4px;
  transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  &.active,
  &:hover,
  &:focus,
  &:focus-within,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 1;
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.15;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    transition: opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`},
      font-weight
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
    &.active,
    &:hover,
    &:focus,
    &:focus-within,
    &:focus-visible {
      font-weight: 700;
    }
  }
  .active-bg {
    position: absolute;
    inset: 0;
    background-color: ${({ theme }) => theme.colors.navItemBackground};
    border-radius: 90px;
    z-index: -1;
    pointer-events: none;
  }

  &:focus,
  &.focus-within {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 1px ${({ theme }) => rgba(theme.colors.primary, 0.5)};
  }
`;

type Link = {
  label: string;
  path: string;
  disabled: boolean;
  isHidden?: () => boolean;
};

interface NavbarProps {
  className?: string;
  links: Link[];
  linkRender: (link: Link, i: number) => JSX.Element;
}

export const Navbar: FunctionComponent<NavbarProps> = ({
  className,
  links,
  linkRender,
}) => {
  return (
    <NavbarWrapper className={className || ""}>
      <LinksContainer>
        {links
          .filter((l) => !l.disabled && (l.isHidden ? !l.isHidden() : true))
          .map(linkRender)}
      </LinksContainer>
    </NavbarWrapper>
  );
};
